import { ClaimService } from '@dav-core/services/claim.service';
import { Claim } from '@dav-model/api/response/claims.response';
import { ClaimsFilter } from '@dav-model/claims-filter';

import * as ClaimsActions from './claims.actions';

export interface State {
  claims: Claim[];
  claimsFilter: ClaimsFilter;
  gridClaims: Claim[];
}

const InitialState: State = {
  claims: [],
  claimsFilter: new ClaimsFilter(),
  gridClaims: []
};

export function reducer(state = InitialState, action: ClaimsActions.All): State {
  switch (action.type) {

    case ClaimsActions.GET_CLAIMS_SUCCESS: {
      return {
        ...state,
        claims: action.payload.claims,
        gridClaims: action.payload.claims,
        claimsFilter: action.payload.filters
      };
    }

    case ClaimsActions.FILTER_GRID: {
      const claims = ClaimService.filter(action.payload, state.claims);

      return { ...state, gridClaims: claims };
    }

    default: {
      return state;
    }
  }
}


